import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RoutesRecognized } from '@angular/router';
import Utils from 'src/app/common/utils/app.utils';
import { userType } from '../../common/enum/userType';
import { Menu } from '../../common/models/menu';
import { AuthService, MenuService } from '../../services';

@Component({
    selector: 'haven-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MenuComponent implements OnInit {
  showChildnav = false;
  currentId;
  userType = userType;
  accessMenus: Menu[] = [];
  loggedInUser: string;
  loggedInUserRole: string;
  constructor(
    public menuService: MenuService,
    public router: Router,
    private authService: AuthService
  ) {
  }

  connectionSubHeader = [{
      displayName: 'Connections',
      url: '/connectionsconfiguration/connections',
      order: 1},
      {
      displayName: 'Libraries',
      url: '/connectionsconfiguration/libraries',
      order: 2},
      {
      displayName: 'Administrators',
      url: '/connectionsconfiguration/administrators',
      order: 3}];

  ngOnInit() {
    this.accessMenus = this.menuService.getAllMenus();
    this.loggedInUser = this.authService.getUserFullName();
    this.loggedInUserRole = this.authService.getUserRole();
  }
  getuserRole(type: string) {
    return Utils.getUserRole(type);

  }


}
